/* eslint-disable class-methods-use-this */
import React from 'react';
import { useRouteData, useSiteData, Head } from 'react-static';
// template components
import Page from '@nmx/template/dist/componentLibrary/layout/Page';
// native components
import BoardOfTrusteesSection from './components/boardOfTrusteesSection';
import CdioSection from './components/cdioSection';
import CeoSection from './components/ceoSection';
import CfoSection from './components/cfoSection/cfoSection';
import ChiefFieldOfficerSection from './components/chiefFieldOfficerSection';
import ChiefStrategyOfficerSection from './components/chiefStrategyOfficerSection';
import ChroSection from './components/chroSection';
import CioSection from './components/cioSection';
import ClpaoSection from './components/clpaoSection';
import CpoSection from './components/cpoSection';
import HeaderSection from './components/headerSection';
import Metadata from './components/metadata';

export default () => {
  const { config, dynamicConfig } = useSiteData();
  const { pageProps } = useRouteData();

  return (
    <Page
      {...pageProps} // defined in route.js
      headComponent={Head}
      dynamicConfig={dynamicConfig}
      config={config}
      disableDisclaimerTopBorder
      breadcrumbsNavigationConfig={[
        {
          pageName: 'Home',
          linkUrl: '/',
          linkAriaLabel: 'Northwestern Mutual Home',
        },
        {
          pageName: 'Our Leaders',
          linkUrl: '/leaders/',
          linkAriaLabel: 'Northwestern Mutual Leaders',
        },
      ]}>

      <Metadata
        pageDescription={pageProps.pageDescription}
        pageTitle={pageProps.pageTitle}
      />

      <HeaderSection />

      {/* CHIEF EXECUTIVE OFFICER SECTION */}
      <CeoSection />

      {/* CHIEF INVESTMENT OFFICER */}
      <CioSection />

      {/* CHIEF HUMAN RESOURCES OFFICER SECTION */}
      <ChroSection />

      {/* CHIEF DIGITAL & INFORMATION OFFICER SECTION */}
      <CdioSection />

      {/* CHIEF FINANCIAL OFFICER SECTION */}
      <CfoSection />

      {/* CHIEF PRODUCT OFFICER SECTION */}
      <CpoSection />

      {/* CHIEF LEGAL & PUBLIC AFFAIRS OFFICER SECTION */}
      <ClpaoSection />

      <ChiefFieldOfficerSection />

      <ChiefStrategyOfficerSection />

      <BoardOfTrusteesSection />

    </Page>
  );
};
